import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function ConfirmationModal({
    isOpen,
    onClose,
    onConfirm
}) {

    // const toggle = () => setModal(!modal);

    return (
        <>

            <Modal isOpen={isOpen} toggle={onClose} centered>
                <ModalBody>
                    <div className='py-4 px-2'>
                        <h3 className='main_heading'>
                            Are you sure you want to delete?
                        </h3>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="main_button" onClick={onConfirm}>Yes</button>
                    <button className="table_delete" onClick={onClose}>Cancel</button>
                </ModalFooter>
            </Modal>


        </>
    );
}

export default ConfirmationModal;